module.exports = __webpack_public_path__ + "static/img/undraw_voice_control_ofo1.4ec1952.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/undraw_voice_control_ofo1.png
// module id = PIFJ
// module chunks = 3